const ArticleListItem = () => import('../../components/article-list-item/index.vue');

export default {
    name: 'RecoveryPage',
    
    components: {
        'list-item': ArticleListItem
    },

    computed: {
        list() {
            return this.$store.getters.getArticleList(10002);
        }
    },

    created() {
        this.$store.dispatch('fetchArticles');
        this.$store.commit('setMenuItems', this.list);
        this.$store.commit('setMenuDetails', { title: 'Recovery', slug: 'recovery', back_url: '/action/operations' });
    }
};